import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { Hero, Locale } from '@/service/api/landingPage'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useHero = () => {
  const { windowSize } = useScreen()

  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale

  const [heroData, setHeroData] = useState<Hero>(
    () =>
      getLPTranslationData({
        landingPage: 'software',
        container: 'heroContainer',
        locale,
      }) as Hero,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: 'software',
      container: 'heroContainer',
      locale,
    }) as Hero

    setHeroData(translationsObject)
  }, [locale])

  const fontSizeByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h2' as const,
      },
      791: {
        title: 'h5' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizeByScreenSize[1440]
    if (width <= 791) return fontSizeByScreenSize[791]

    return fontSizeByScreenSize[1440]
  }, [width, fontSizeByScreenSize])

  return {
    fontSizes,
    heroData,
  }
}
